(function () {
  'use strict';
  var PX = 'tp';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }

  var el = null, timer = 0, left = 6000, t0 = 0, isHeld = false, opened = false, kb = false, moved = false, wrap = null, raf = 0;
  var DELAY = 6000;

  /* keyboard or pointer? (only keyboard users get focus moved into the popover) */
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Tab') kb = true; }, true);
  document.addEventListener('pointerdown', function () { kb = false; }, true);
  var trigger = null;   /* the add button that was used (the browser may drop focus while it is disabled) */
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-add-button]'); if (b) trigger = b; }, true);

  function visibleCart() {
    var list = document.querySelectorAll('.site-header__cart');
    for (var i = 0; i < list.length; i++) { var r = list[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0) return list[i]; }
    return null;
  }

  function build() {
    if (el && document.body.contains(el)) return el;
    var W = words();
    el = document.createElement('div');
    el.className = PX + '-ui';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-labelledby', PX + '-ui-title');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('tabindex', '-1');
    el.innerHTML =
      '<div class="' + PX + '-ui__head"><span class="' + PX + '-ui__check" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span>' +
      '<p class="' + PX + '-ui__title" id="' + PX + '-ui-title" role="status">' + esc(W.added) + '</p>' +
      '<button type="button" class="' + PX + '-ui__x" data-ui-close aria-label="' + esc(W.close) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
      '<div class="' + PX + '-ui__body" data-ui-body></div>' +
      '<div class="' + PX + '-ui__bar" aria-hidden="true"></div>';
    el.addEventListener('click', function (e) { if (e.target.closest('[data-ui-close]')) close(true); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(true); } else trap(el, e); });
    el.addEventListener('mouseenter', hold); el.addEventListener('mouseleave', release);
    el.addEventListener('focusin', hold); el.addEventListener('focusout', function () { setTimeout(release, 0); });
    document.body.appendChild(el);
    return el;
  }

  function content(item, c) {
    var W = words(), out = '';
    if (item) {
      var price = item.final_price != null ? item.final_price : item.price;
      var vt = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="' + PX + '-ui__var">' + esc(item.variant_title) + '</span>' : '';
      out += '<div class="' + PX + '-ui__item"><span class="' + PX + '-ui__pic">' + pic(item.image || item.featured_image && item.featured_image.url, 68) + '</span>' +
        '<span class="' + PX + '-ui__info"><a class="' + PX + '-ui__name" href="' + esc(item.url || cartUrl()) + '">' + esc(item.product_title || item.title) + '</a>' + vt +
        '<span class="' + PX + '-ui__price">' + esc(W.qty_short || 'Qty') + ' ' + esc(item.quantity) + ' · ' + money(price) + '</span></span></div>';
    }
    out += '<p class="' + PX + '-ui__sum"><span>' + esc(count(c.item_count, W)) + ' · ' + esc(W.subtotal) + '</span><strong>' + money(c.total_price) + '</strong></p>' +
      '<div class="' + PX + '-ui__actions"><a class="' + PX + '-ui__btn ' + PX + '-ui__btn--primary" href="' + esc(checkoutUrl()) + '">' + esc(W.checkout) + '</a>' +
      '<a class="' + PX + '-ui__btn" href="' + esc(cartUrl()) + '">' + esc(W.view_cart) + '</a></div>' +
      '<p class="' + PX + '-ui__ship">' + esc(W.ship) + '</p>';
    return out;
  }

  /* under the visible header cart icon; the header may be hidden by the sticky behaviour, so measure against its wrapper */
  function place() {
    if (!el) return;
    var vw = document.documentElement.clientWidth, top = 84, right = 16, arrow = 40, c = visibleCart();
    if (c) {
      var cr = c.getBoundingClientRect();
      var w = c.closest('.section-header') || c.closest('.shopify-section');
      var wr = w ? w.getBoundingClientRect() : { top: 0 };
      var base = w && w.classList.contains('is-sticky') ? 0 : wr.top;
      top = base + (cr.bottom - wr.top) + 14;
      right = Math.max(12, vw - cr.right - 10);
      var pw = el.offsetWidth || 380;
      arrow = Math.min(Math.max(vw - right - (cr.left + cr.width / 2), 34), pw - 34);
    }
    el.style.top = Math.max(top, 8) + 'px';
    el.style.right = right + 'px';
    el.style.setProperty('--' + PX + '-ui-arrow', arrow + 'px');
  }
  function onMove() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; place(); }); }

  function run() { clearTimeout(timer); t0 = Date.now(); timer = setTimeout(function () { close(false); }, left); }
  function hold() {
    if (!opened || isHeld) return;
    isHeld = true; clearTimeout(timer); left = Math.max(600, left - (Date.now() - t0)); el.classList.add('is-held');
  }
  function release() {
    if (!opened || !isHeld) return;
    if (el.matches(':hover') || el.contains(document.activeElement)) return;
    isHeld = false; el.classList.remove('is-held'); run();
  }

  function onDoc(e) { if (opened && el && !el.contains(e.target)) close(false); }
  function onKey(e) { if (opened && e.key === 'Escape') close(true); }

  function openUi(item, c, byKeyboard) {
    build();
    el.querySelector('[data-ui-body]').innerHTML = content(item, c);
    var bar = el.querySelector('.' + PX + '-ui__bar');
    if (opened && bar) { bar.style.display = 'none'; void bar.offsetWidth; bar.style.display = ''; }
    var vc = visibleCart(); wrap = vc ? vc.closest('.section-header') : null;
    if (wrap) wrap.classList.add(PX + '-keep');
    place();
    setTimeout(function () { if (opened) place(); }, 360);   /* the header may still be sliding back in */
    left = DELAY; isHeld = false; el.classList.remove('is-held');
    if (!opened) {
      opened = true;
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
      document.addEventListener('pointerdown', onDoc, true);
      document.addEventListener('keydown', onKey, true);
      window.addEventListener('scroll', onMove, { passive: true });
      window.addEventListener('resize', onMove);
    }
    moved = false;
    if (byKeyboard) { moved = true; el.focus({ preventScroll: true }); }
    run();
  }

  function close(restore) {
    clearTimeout(timer);
    if (!el || !opened) return;
    opened = false; isHeld = false;
    el.classList.remove('is-open', 'is-held'); el.setAttribute('aria-hidden', 'true');
    if (wrap) { wrap.classList.remove(PX + '-keep'); wrap = null; }
    document.removeEventListener('pointerdown', onDoc, true);
    document.removeEventListener('keydown', onKey, true);
    window.removeEventListener('scroll', onMove);
    window.removeEventListener('resize', onMove);
    if (moved && restore !== false && lastFocus && document.body.contains(lastFocus) && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    moved = false;
  }

  function afterAdd(after) {
    if (after === 'cart') return false;
    var item = lastAdded && lastAdded.items && lastAdded.items[0] ? lastAdded.items[0] : null;
    var byKeyboard = kb;
    lastFocus = trigger || (document.activeElement && document.activeElement !== document.body ? document.activeElement : lastFocus);
    T().cart.get().then(function (c) { openUi(item, c, byKeyboard); }).catch(function () {});
    return true;
  }

  function init() {
    if (!customElements.get(PX + '-faq-list')) customElements.define(PX + '-faq-list', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.onToggle = function (e) {
          var d = e.target; if (!d || d.tagName !== 'DETAILS' || !d.open) return;
          [].forEach.call(self.querySelectorAll('details[open]'), function (o) { if (o !== d) o.removeAttribute('open'); });
        };
        this.addEventListener('toggle', this.onToggle, true);
      }
      disconnectedCallback() { this.removeEventListener('toggle', this.onToggle, true); }
    });
  }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'tp';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
